import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "VolumeMute"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M23.25 9.30749L22.1925 8.24999L19.5 10.9425L16.8075 8.24999L15.75 9.30749L18.4425 12L15.75 14.6925L16.8075 15.75L19.5 13.0575L22.1925 15.75L23.25 14.6925L20.5575 12L23.25 9.30749ZM13.5 22.5C13.2996 22.4992 13.1078 22.4181 12.9675 22.275L7.2525 16.5H2.25C1.83579 16.5 1.5 16.1642 1.5 15.75V8.24999C1.5 7.83578 1.83579 7.49999 2.25 7.49999H7.2525L12.9675 1.72499C13.26 1.4342 13.7325 1.4342 14.025 1.72499C14.1663 1.86346 14.2472 2.05216 14.25 2.24999V21.75C14.25 22.1642 13.9142 22.5 13.5 22.5ZM3 15H7.5C7.71863 14.9986 7.92993 15.0788 8.0925 15.225L12.75 19.9275V4.07249L8.0925 8.77499C7.92993 8.92118 7.71863 9.00142 7.5 8.99999H3V15Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/VolumeMute.vue"]]);
